import { useSelector } from 'react-redux';
import {
  clientId,
  clientData,
  currentClientSelected,
  isLinkedInConfigured,
  userEmail,
  userRole,
} from '../store/login/login.selectors';

export const useProfile = () => {
  // get email id
  const emailId = useSelector(userEmail) as string;
  //   get customerId
  const clientList = useSelector(clientData) as Array<{ CustomerKey: string; CustomerName: string; key: string }> || [];
  const currentSelectedIndex = useSelector(currentClientSelected) as string;
  const currentClientId = useSelector(clientId) as string;
  const currentIndex = parseInt(currentSelectedIndex) || 0;
  const currentClient =
    clientList.find((client) => client.CustomerKey === currentClientId) || clientList[currentIndex];
  const customerId = currentClient?.CustomerKey || '';
  const clientName = currentClient?.CustomerName || '';
  const userRoleName = useSelector(userRole) as string;
  const isLinkedInIdConfigured = useSelector(isLinkedInConfigured) as boolean;
  const clientSecret = currentClient?.key || '';
  return { emailId, customerId, clientName, userRoleName, isLinkedInIdConfigured, clientSecret };
};
